import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCartLoading = (isLoading) => ({
  type: actionTypes.SET_CART_ITEMS_LOADING,
  payload: isLoading
})
